import React from 'react';
import PageHeader from '../components/HeroSection';
import StaticGalleryResponsive from '../components/StaticGalleryResponsive';
import ContactSectionDark from '../components/ContactSectionDark';
import BookSection from '../components/BookSection';
import { Helmet } from 'react-helmet';
const GalleryPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
  <title>Hair Extensions & Color Gallery | Hair to Dye For</title>
  <meta name="description" content="Browse real client transformations featuring extensions, balayage, vivid color and more at our Easton, PA salon." />
  <meta property="og:title" content="Hair Gallery | Extensions & Color in Easton" />
  <meta property="og:description" content="See the stunning results of our hair services. Extensions, cuts, color and more by Hair to Dye For." />
  <meta property="og:url" content="https://www.hairtodyeforeaston.com/gallery" />
  <meta property="og:type" content="website" />
  <meta name="keywords" content="hair transformation gallery, before after hair Easton, extension photos, balayage gallery Easton PA" />
  <link rel="canonical" href="https://www.hairtodyeforeaston.com/gallery" />
</Helmet>
      {/* Page Header with Hero */}
      <PageHeader pageTitle="GALLERY" />
<h1 className="sr-only">Before & After: Hair Transformations</h1>
      {/* Gallery Section - Add this line */}
      <StaticGalleryResponsive />

      {/* Book Section */}
      {/* <BookSection /> */}

      {/* Contact Section */}
      <ContactSectionDark />
    </div>
  );
};

export default GalleryPage;